import React from "react";
import "./Header.css";
import background from "../../assets/images/bg.png";

const Header = () => {
	React.useEffect(() => {
		document.documentElement.style.setProperty("--header-bg", `url(${background})`);
	}, []);
	
	return (
		<>
			<header className="header">
				<div className="header-content">
					<a href="#hero"><img src="/Eo Arts Logo.png" alt="Eo Arts Logo" className="header-logo" /></a>
				</div>
			</header>
			<nav className="nav-links">
				<div className="nav-links-content">
					<a href="#services" className="nav-item">Services</a>
					<a href="#about" className="nav-item">À propos</a>
					<a href="#testimonials" className="nav-item">Témoignages</a>
					<a href="#contact" className="nav-item">Contact</a>
				</div>
			</nav>
		</>
	);
};

export default Header;
